import * as yup from 'yup';

export const BookValidation = yup.object({
  author: yup.string('Enter Auhor Name').required('Author Name is required'),
  bookName: yup.string('Enter Name').required('Name is required'),
  bookNo: yup
      .string('Enter Book No')
      .required('Book no is required'),
});

